import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import AddressScrollPicker from 'components/form/AddressScrollPicker'
import BrandedButton from 'components/BrandedButton'
import GenericStatusLoading from 'components/GenericStatusLoading'
import { validateMultiAddressForm } from 'utilities/formValidator.util'
import { updateAddress, loadAddresses } from './actions'
import styles from './styles.scss'

export class MultipleAddressStageComponent extends Component {
  static propTypes = {
    addresses: PropTypes.array,
    title: PropTypes.string,
    subHeading: PropTypes.string,
    helpText: PropTypes.string,
    selectedAddress: PropTypes.string,
    onContinueAction: PropTypes.func,
    loadAddresses: PropTypes.func,
    isLoading: PropTypes.bool,
  }

  static defaultProps = {
    addresses: [],
    title: 'Multiple addresses found at this location',
    subHeading: '<p>Please confirm your address</p>',
    helpText: '<p>Can\'t find your address? Please go back and try again or contact us on 1300 123 455</p>',
    selectedAddress: null,
    onContinueAction: f => f,
    loadAddresses: f => f,
    isLoading: false,
  }

  constructor(props) {
    super(props)
    this.state = { error: '' }
  }

  componentDidMount() {
    if (this.props.addresses.length === 0) {
      this.props.loadAddresses()
    }
  }

  onContinue = (event) => {
    event.preventDefault()
    const valid = validateMultiAddressForm(this.props.selectedAddress)
    if (valid === true) {
      this.props.onContinueAction(this.props.selectedAddress)
    } else {
      this.setState({ error: valid })
    }
  }

  render() {
    if (this.props.isLoading && this.props.addresses.length === 0) {
      return (
        <div className={styles.loadingWrapper}>
          <GenericStatusLoading extraClassName={styles.loader} />
        </div>
      )
    }
    return (
      <div className={styles.wrapper}>
        <h3>{this.props.title}</h3>
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: this.props.subHeading }}
        />
        <AddressScrollPicker
          addresses={this.props.addresses}
          disabled={this.props.isLoading}
          error={this.state.error}
        />
        <div
          className={styles.helpText}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: this.props.helpText }}
        />
        <div>
          <div className={styles.buttonWrapper}>
            <BrandedButton onClick={this.onContinue} labelText="Continue" fitContent />
          </div>
          <a className={styles.backButton} href="/">Back</a>
          <div className="clearfix" />
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  // whatever is returned will show up as props
  return {
    isLoading: state.checkoutReducer.isLoading,
    selectedAddress: state.checkoutReducer.multiAddressStageSelectedId,
    addresses: state.checkoutReducer.multiAddressStageAddresses,
  }
}

// Anything returned from this function will end up as props
function mapDispatchToProps(dispatch) {
  // Whenever dispatch is called the result should be passed
  // to all of the reducers
  return bindActionCreators(
    { onContinueAction: updateAddress, loadAddresses },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(MultipleAddressStageComponent)



// WEBPACK FOOTER //
// ./containers/stages/MultipleAddressStage/index.jsx